import event from '@drivesally/sally-fw/lib/event/event';

export default event('/branch/working-hours-editor/show');
